<template>
  <div class="row">
    <div class="col-12 col-md-8">
      <div class="candidate-home__stream mb-4 pb-4">
        <div class="candidate-home__tags">
          <a
            href="#"
            v-for="f in selectedFilters"
            :key="f.key"
            @click.prevent="resetFilter(f.key)"
          >
            <b-icon-x-circle-fill />
            {{ f.value }} <span v-if="f.key == 'salary'">грн.</span>
          </a>
        </div>
        <b-overlay
          :opacity="0"
          :show="isLoading"
          class="mb-4"
          spinner-variant="warning"
        >
          <template v-if="vacancies.length">
            <vacancyCard :v="v" v-for="v in vacancies" :key="v.uid" />
          </template>
          <template v-if="!isLoading && !vacancies.length">
            <div class="no-data text-center py-4 my-4">
              <h5 class="mb-4 mt-4">Нічого не знйдено</h5>
              <img src="@/assets/img/no-data.svg" width="220" alt="" />
            </div>
          </template>
        </b-overlay>
        <div
          v-if="!isLoading && !last_page"
          class="d-flex py-3 justify-content-center"
        >
          <b-button @click="fetchVacancies" variant="outline-primary">
            Завантажити ще {{ perPage }}
          </b-button>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-4">
      <div class="candidate-home__filter">
        <div class="filter-group">
          <h4 class="title mb-4">Категорія</h4>
          <v-select
            placeholder="Оберіть категорію"
            :options="['А', 'Б', 'В']"
            v-model="vaccancy_filter.job_category"
          />
        </div>
        <div class="filter-group salary">
          <h4 class="title mb-4">Рівень заробітної плати від</h4>
          <vue-slider
            v-model="vaccancy_filter.salary"
            :min="min_salary"
            :max="45000"
            :step="500"
            :height="4"
            :dotSize="22"
            :lazy="true"
            tooltip="always"
            tooltipPlacement="top"
            :tooltip-formatter="(val) => val.toLocaleString('en') + ' грн.'"
          />
        </div>
        <div class="filter-group">
          <h4 class="title mb-2">Регіон</h4>
          <v-select
            placeholder="Оберіть регіон"
            :reduce="(option) => option.label.trim()"
            :options="formattedRegions"
            v-model="vaccancy_filter.region"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vacancyCard from "@/components/candidate/vacancy-card.vue";
import VueSlider from "vue-slider-component";
import regions from "@/assets/data/regions.json";
export default {
  components: {
    vacancyCard,
    VueSlider,
  },
  data() {
    return {
      isLoading: false,
      perPage: 24,
      regions: regions,
      vacancies: [],
      last_page: false,
      lastItem: null,
      filtered: true,
      min_salary: 5000,
      vaccancy_filter: {
        salary: 5000,
        region: null,
        job_category: null,
      },
    };
  },
  computed: {
    selectedFilters() {
      let items = [];
      for (var key in this.vaccancy_filter) {
        if (this.vaccancy_filter[key] && key !== "salary") {
          items.push({
            key: key,
            value: this.vaccancy_filter[key],
          });
        }
        if (key == "salary" && this.vaccancy_filter[key] > this.min_salary) {
          items.unshift({
            key: key,
            value: this.vaccancy_filter[key],
          });
        }
      }

      return items;
    },

    formattedRegions() {
      return this.regions.map((el) => {
        return {
          value: el.level_1,
          label: el.name_ua,
        };
      });
    },
  },
  watch: {
    vaccancy_filter: {
      deep: true,
      handler() {
        this.searchVaccancies();
      },
    },
  },
  methods: {
    resetFilter(key) {
      if (key == "salary") {
        this.vaccancy_filter.salary = this.min_salary;
      } else {
        this.vaccancy_filter[key] = null;
      }
    },
    async searchVaccancies() {
      this.isLoading = true;
      this.filtered = true;
      this.vacancies = [];
      const args = {
        collectionName: "vacancies",
        limitBy: this.perPage,
        where3: ["salary", ">", this.vaccancy_filter.salary],
      };
      if (this.vaccancy_filter.region) {
        args["where"] = ["region", "==", this.vaccancy_filter.region];
      }
      if (this.vaccancy_filter.job_category) {
        args["where2"] = [
          "job_category",
          "==",
          this.vaccancy_filter.job_category,
        ];
      }
      console.log(args);
      if (this.vacancies.length > 0) {
        args["startAfter"] = this.lastItem;
      }
      let result = await this.$db.getCollection(args);

      result.docs.forEach((el) => {
        this.vacancies.push(el);
      });

      this.lastItem = result.lastVisible;
      if (result.docs.length < this.perPage) {
        this.last_page = true;
      }
      this.isLoading = false;
    },
    async fetchVacancies() {
      this.isLoading = true;

      const args = {
        collectionName: "vacancies",
        limitBy: this.perPage,
        order: ["deadline", "desc"],
      };
      console.log(args);
      if (this.vacancies.length > 0) {
        args["startAfter"] = this.lastItem;
      }
      let result = await this.$db.getCollection(args);
      result.docs.forEach((el) => {
        this.vacancies.push(el);
      });

      this.lastItem = result.lastVisible;
      if (result.docs.length < this.perPage) {
        this.last_page = true;
      }
      this.isLoading = false;
    },
  },
  mounted() {
    this.fetchVacancies();
  },
};
</script>

<style lang="scss">
/* Set the theme color of the component */
$themeColor: var(--primary-color);

/* import theme style */
@import "~vue-slider-component/lib/theme/default.scss";
h5 {
  color: var(--primary-color);
}
.candidate-home {
  &__tags {
    a {
      display: inline-block;
      background: var(--secondary-color);
      color: var(--primary-color);
      text-decoration: none;
      font-weight: 600;
      margin-right: 20px;
      margin-bottom: 20px;
      padding: 3px 12px 3px 8px;
      border-radius: 18px;
      box-shadow: 0px 3px 10px 0px rgba(#000, 0.2);
      svg {
        margin-right: 6px;
      }
      &:hover {
        color: var(--primary-color);
        svg {
          fill: #f00;
        }
      }
    }
  }
  &__filter {
    padding-left: 30px;
    .filter-group {
      padding-bottom: 16px;
      margin-bottom: 16px;
      // border-bottom: 1px solid #ccc;
      padding-top: 20px;

      .title {
        color: #666 !important;
        font-size: 18px;
      }
      &.salary {
        .title {
          margin-bottom: 40px !important;
        }
        input {
          font-size: 18px;
          border-radius: 6px;
          color: #666;
          border: none;
          padding: 0px 12px;
          width: 120px;
          height: 36px;
          text-align: center;
          background: #ccc;
          margin-top: 20px;
          margin-bottom: 10px;
        }
      }
    }
  }
}
</style>
